<template>
  <div class="data-update-md">
    <svg
      class="svg-update"
      xmlns="http://www.w3.org/2000/svg"
      width="14"
      height="14"
      viewBox="0 0 14 14"
      fill="none"
    >
      <path
        fill-rule="evenodd"
        clip-rule="evenodd"
        d="M7 0C3.13359 0 0 3.13359 0 7C0 10.8664 3.13359 14 7 14C10.8664 14 14 10.8664 14 7C14 3.13359 10.8664 0 7 0ZM7.5 2C7.77656 2 8 2.22344 8 2.5C8 2.77656 7.77656 3 7.5 3C7.22344 3 7 2.77656 7 2.5C7 2.22344 7.22344 2 7.5 2ZM8.48638 11H7.47471H6.4786H5.51362C5.23813 11 5.01556 10.8095 5.01556 10.5738C5.01556 10.3381 5.23813 10.1476 5.51362 10.1476H6.4786V5.85239H5.49805C5.22257 5.85239 5 5.66193 5 5.42619C5 5.19046 5.22257 5 5.49805 5H6.4786H6.97665C7.25214 5 7.47471 5.19046 7.47471 5.42619V10.1476H8.48638C8.76187 10.1476 9 10.3381 9 10.5738C9 10.8095 8.76187 11 8.48638 11Z"
        fill="#2762FF"
      />
    </svg>
    <div class="text">
      <!-- 本页数据更新于  -->
      {{ $t("lanV4.updateDataTime") }} {{ headerUpdateTime }}
    </div>
  </div>
</template>
<script>
import { formatTime } from "@/apis/newmethods";
export default {
  data() {
    return {
      headerUpdateTime: null,
    };
  },
  methods: {
    // 获取更新时间
    getData() {
      const paramsData = {
        companyId:undefined,
      };
      this.$http({
        url: this.$store.state.url.agent.index,
        params: paramsData,
        // method: "get",
        // apiType: "fe-json-server",
      }).then(({ data, code, msg }) => {
        if (data && code.toString() === "0") {
          this.headerUpdateTime = data ? formatTime(data.lastUpdateTime) : null;
        } else {
          this.$bus.$emit("alert", { type: "error", message: msg });
        }
      });
    },
  },
  created() {
    this.getData();
  },
};
</script>